import axios from "axios";
import { getToken } from "./authService";
import { hideLoader } from "../helpers/loader";
import { NotificationManager } from "react-notifications";
import { UserDataContext } from "./../../context/userContext";

// A request can fail with no answer at all (offline, server restarting, blocked): there is then no
// error.response, and reading .data from it crashed the page (QA 2026-10-26). Always return something readable.
const errData = (error) =>
  (error && error.response && error.response.data) || {
    message: typeof navigator !== "undefined" && navigator.onLine === false
      ? "You seem to be offline. Check your connection and try again."
      : "We couldn’t reach TheNewspaperStand just now. Please try again.",
    data: {},
  };

export let baseUrl = process.env.REACT_APP_BASE_URL;
// export let baseUrl = "https://api.thenewspaperstand.com";
// export let baseUrl = process.env.REACT_APP_BASE_URL;
// export let baseUrl = "http://d3898537932a.ngrok.io";

export const httpPost = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.post(`${baseUrl}/api/${url}`, postBody, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();

    if (
      error?.response?.data?.message ===
      "Unauthorized, Your token is invalid or expired"
    ) {
      NotificationManager.error(
        "Your token is invalid or expired, please login",
        "Opps!",
        5000
      );
    }
    if (errData(error).message === "Validation Error!") {
      NotificationManager.error(
        Object.values(errData(error).data).join("  ")
      );
      return;
    }
    return { er: errData(error) };
  }
};

export const httpPostData = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }

  try {
    const res = await axios.post(`${baseUrl}/api${url}`, postBody, {
      headers: {
        Authorization: `Bearer ${localStorage.token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    if (
      errData(error).message ===
      "Unauthorized, Your token is invalid or expired"
    ) {
      NotificationManager.error(
        "Your token is invalid or expired, please login",
        "Opps!",
        5000
      );
    }
    return { er: errData(error) };
  }
};

export const httpGet = async (url) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.get(`${baseUrl}/api/${url}`, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    if (
      errData(error).message ===
      "Unauthorized, Your token is invalid or expired"
    ) {
      localStorage.setItem("expiredToken", "true");
      localStorage.setItem("showModal", "true");
      return { er: errData(error).message };
    }
    if (errData(error).message === "Validation Error!") {
      NotificationManager.error(
        Object.values(errData(error).data).join("  ")
      );
      return;
    }
    return { er: errData(error) };
  }
};

export const httpPut = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.put(`${baseUrl}/api/${url}`, postBody, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    NotificationManager.error(
      "Your token is invalid or expired, please login",
      "Opps!",
      5000
    );
    if (
      errData(error).message ===
      "Unauthorized, Your token is invalid or expired"
    ) {
    }
    return { er: errData(error) };
  }
};

export const httpPatch = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.patch(`${baseUrl}/api/${url}`, postBody, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    NotificationManager.error(
      "Your token is invalid or expired, please login",
      "Opps!",
      5000
    );
    if (
      errData(error).message ===
      "Unauthorized, Your token is invalid or expired"
    ) {
    }
    return { er: errData(error) };
  }
};

export const httpDelete = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.delete(`${baseUrl}/api/${url}`, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res;
  } catch (error) {
    hideLoader();
    hideLoader();
    return { er: errData(error) };
  }
};
